var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$props.isLoading)?_c('div',{staticClass:"d-flex justify-center items-center pa-8"},[_c('VProgressCircular',{attrs:{"indeterminate":""}})],1):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }